import { CompanyEnrichmentLevel } from "@shaarp/common";

/** Maps each enrichment level to a human-readable label. */
export const enrichmentLevelLabels: Record<CompanyEnrichmentLevel, string> = {
  0: "CREATED",
  1: "IDENTIFIED",
  2: "QUALIFIED",
  3: "DISCOVERED",
  4: "COMPLETE",
};

/** Maps each enrichment level to a badge variant for visual styling. */
export const enrichmentLevelVariants: Record<
  CompanyEnrichmentLevel,
  "default" | "secondary" | "destructive" | "outline"
> = {
  0: "destructive",
  1: "outline",
  2: "outline",
  3: "secondary",
  4: "default",
};
